import { graphql } from 'gql';

export const uerContractActsKC3Gql = graphql(`
    query uerContractActsKC3(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: ActKC3RegistryItemFilterInput
        $order: [ActKC3RegistryItemSortInput!]
    ) {
        uerContractActsKC3(skip: $skip, take: $take, contractId: $contractId, where: $where, order: $order) {
            items {
                actKC2Date
                actKC2FullNumber
                actKC2Id
                actKC2ReportingFinishDate
                actKC2ReportingStartDate
                actKC2Status
                actKC2TotalCost
                actKC2TotalCostWithTax
                actKC3CanDelete
                actKC3CanEdit
                actKC3CorrectionNumber
                actKC3Date
                actKC3FromWorkStartCost
                actKC3FromYearStartCost
                actKC3FullNumber
                actKC3Id
                actKC3IsCorrection
                actKC3IsInactive
                actKC3Number
                actKC3ReportedPeriodCost
                actKC3ReportingFinishDate
                actKC3ReportingStartDate
                actKC3TotalCostWithTax
                contractId
                isFinal
                rootContractObjectId
                workOrderId
            }
            totalCount
        }
    }
`);

export const uerContractActsKC3FullNumberFilterGql = graphql(`
    query uerContractActsKC3FullNumberFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerContractActsKC3FullNumberFilter(skip: $skip, take: $take, contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const uerContractActsKC3DateFilterGql = graphql(`
    query uerContractActsKC3DateFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: FilterValueOfNullableOfDateOnlyFilterInput
    ) {
        uerContractActsKC3DateFilter(skip: $skip, take: $take, contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const uerRemoveActsKC3Gql = graphql(`
    mutation uerRemoveActsKC3($contractId: Long!, $actKC3Ids: [Long!]!) {
        uerRemoveActsKC3(contractId: $contractId, actKC3Ids: $actKC3Ids) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractWorkOrdersBaseDataGql = graphql(`
    query uerContractCommonData($contractUniqueId: String!) {
        uerContractCommonData(contractUniqueId: $contractUniqueId) {
            data {
                contractNavigation {
                    workOrderNavs {
                        id
                        internalNumber
                        name
                        signingDate
                        status
                        actKC2Navs {
                            id
                            status
                        }
                    }
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerChangeActKC3LevelGql = graphql(`
    mutation uerChangeActKC3Level($actKC3Level: ActKC3LevelEnum!, $contractId: Long!) {
        uerChangeActKC3Level(actKC3Level: $actKC3Level, contractId: $contractId) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
